module.exports = __webpack_public_path__ + "img/noSaleCard.a0f1e8eb.png";